import { module as m } from 'modujs';
import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default class extends m {
    constructor(m) {
        super(m);

        // DOM
        this.dom = {};
    }

    /**
     * INIT
     */
    init() {
        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            spaceBetween: 30,
            modules: [Navigation],
            navigation: {
                nextEl: this.el.querySelector('.arrows .next'),
                prevEl: this.el.querySelector('.arrows .prev'),
            },
            breakpoints: {
                320: {slidesPerView: 1},
                768: {slidesPerView: 3},
                1024: {slidesPerView: 4}
            }
        });
    }

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}

}
